import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { UpdateCheckService } from './updateCheck.service';

interface DialogData {
  version: string;
  buildDate: string;
}

@Component({
  selector: 'update-check-dialog',
  template: `
    <mat-dialog-content>
      <div>
        <strong i18n="@@lib.updateCheckDialog.version">Version</strong>
        {{ data.version }}
      </div>
      <div>
        <strong i18n="@@lib.updateCheckDialog.date">Datum</strong>
        {{ data.buildDate }}
      </div>
      @if(!updateCheckService.isUpdateSupported()) {
        <!-- ohne Service Worker (Mitarbeiter-App, #1403): nur Version und Datum -->
      } @else if(!updateCheckService.updateAvailable()) {
      <button
        mat-raised-button
        color="accent"
        (click)="checkForUpdates()"
        [disabled]="updateCheckService.versionChecking()"
      >
        @if(updateCheckService.versionChecking()) {
        <div class="progress">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        } @else {
        <div class="iconText">
          <mat-icon>cached</mat-icon>
          <span i18n="@@lib.updateCheckDialog.checkForUpdates"
            >Auf Updates prüfen</span
          >
        </div>
        }
      </button>
      } @else {
      <button mat-raised-button color="accent" (click)="refresh()">
        <div class="iconText">
          <mat-icon>arrow_circle_up</mat-icon>
          <span i18n="@@lib.updateCheckDialog.updatesAvailable"
            >Updates verfügbar</span
          >
        </div>
      </button>
      }
    </mat-dialog-content>
  `,
  styles: [
    `
      mat-dialog-content {
        display: grid;
        align-items: center;
        min-width: 20rem;
        gap: 1rem;
        button {
          .progress {
            min-width: 10rem;
          }
          .iconText {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
        }
      }
    `,
  ],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule,
    MatIconModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class UpdateCheckDialog {
  dialogRef = inject(MatDialogRef<UpdateCheckDialog>);
  updateCheckService = inject(UpdateCheckService);
  data = inject<DialogData>(MAT_DIALOG_DATA);

  versionChecking = false;

  ngAfterViewInit() {
    if (this.updateCheckService.isUpdateSupported()) {
      this.checkForUpdates();
    }
  }

  async checkForUpdates(): Promise<void> {
    await this.updateCheckService.checkForUpdates();
  }

  refresh(): void {
    window.location.reload();
  }
}
